import { amConfig } from '../../config/affiliateManager'

export const loadAffiliateVisitorScript = () => {
	// Guard for SSR / unit tests
	if (typeof window === 'undefined') return

	// Feature-flag – default ON when var is undefined, opt-out with "false"
	if (!amConfig.enabled) return

	// Prevent double-injection
	if ((window as any).affiliateManager || document.getElementById('ghl-affiliate')) return

	const script = document.createElement('script')
	script.id = 'ghl-affiliate'
	script.type = 'text/javascript'
	script.async = true
	script.src = 'https://link.msgsndr.com/js/am.js'

	const handler = function (this: any) {
		const rs = this.readyState
		if (!rs || rs === 'complete' || rs === 'loaded') {
			try {
				;(window as any).affiliateManager.init(
					'3XmaqvEJ8FZMBbn41tlv',
					'https://backend.leadconnectorhq.com',
					'.app.prop.ai',
				)
			} catch (_e) {
				// silently ignore
			}
		}
	}

	script.onload = handler
	// @ts-ignore – readyState is for old IE, ignore typing
	;(script as any).onreadystatechange = handler

	// Insert before the first script tag as per GHL docs
	const firstScript = document.getElementsByTagName('script')[0]
	if (firstScript && firstScript.parentNode) {
		firstScript.parentNode.insertBefore(script, firstScript)
	} else {
		document.head.appendChild(script)
	}
}

export const trackLead = (firstName: string, lastName: string, email: string) => {
	// Send affiliate lead event once signup is confirmed
	if (amConfig.enabled) {
		const aff: any = (window as any).affiliateManager
		if (aff && typeof aff.trackLead === 'function') {
			aff.trackLead({ email, firstName, lastName }).then(() => {
				console.log('Lead tracked successfully')
			})
		} else {
			const affiliateQueue: any[] = (window as any)._affiliateManager || []
			;(window as any)._affiliateManager = affiliateQueue
			affiliateQueue.push(['event', 'signup'])
			affiliateQueue.push(['email', email])
		}
	}
}
